import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'gatsby';

export default function LessonList({ lessons, showButtons = true, showLocation = true }) {
  return lessons.length > 0
    ? lessons.map((lesson, index) => (
        <div key={`feature-lesson-${index}`} className="lesson-container">
          <div className="lesson-name">{lesson.name}</div>
          <div className="lesson-image">{lesson.image}</div>
          <div className="lesson-data">
            <div className="lesson-features">
              {lesson.features.length > 0
                ? lesson.features.map((feature, featIndex) => (
                    <div key={`feature-key-${featIndex}`} className="lesson-feature">
                      <FontAwesomeIcon icon={feature.icon ? feature.icon : faCheckCircle} />
                      {feature.name}
                    </div>
                  ))
                : 'No features'}
            </div>
            {showLocation === true && (
              <div className="lesson-locations">
                <FontAwesomeIcon icon={faLocationDot} />{' '}
                {lesson.locations.length > 0
                  ? lesson.locations.map((loc, locIndex) => (
                      <span key={`lesson-${index}-location-${locIndex}`}>
                        <Link to="/locations/placeholder">{loc.name}</Link>
                        {locIndex !== lesson.locations.length - 1 && ', '}
                      </span>
                    ))
                  : 'No Locations'}
              </div>
            )}
          </div>
          {showButtons && <div className="lesson-buttons">Buttons Here</div>}
        </div>
      ))
    : 'No Lessons for this Category';
}
